const ROUTES = {
  HOME: "/",
  // ABOUT: "/about",
  // CONTACT: "/contact",
  // TERMS: "/terms",
  // PRIVACYPOLICY: "/privacypolicy",
  LOGIN: "/login",
  SIGNUP: "/signup",
  FORGOTPASSWORD: "/forgotpassword",
  ALREADY_LOGGED_IN: "/admin",
  LOGOUT: "/logout",
  VERIFY_EMAIL: "/verifyemail",
  CREATE_ACCOUNT: "/createaccount",
  CHECKOUT: "/checkout",
  ADMIN: "/admin",
  // THANKYOU: "/thankyou",
  SUBSCRIPTION_PAYMENT: "/subscriptionpayment",
  TRIAL_EXPIRY: "/trialexpirypage",
  CUSTOMER_RESETPASSWORD: "/:uuid/reset_password",
  CUSTOMER_VERIFYEMAIL: "/:uuid/verify",
  USER_INFO: "/userinformation",
  UNSUBSCRIBE: "/unsubscribe",
  REACTIVATE: "/reactivate",
  PREVIEW: "/preview",
  STORE: "/store/:page?",
  STORE_DEMO: "/demo/:page?",
  THEMES: "/themes",
  EDITOR: "/editor",
  CUSTOMER_LOGIN: "/:uuid/verify_email",
  FREE_TRIAL_LINK: "/free_trial"
}

ROUTES.DASHBOARD = `${ROUTES.ADMIN}/`
ROUTES.CUSTOMER = `${ROUTES.ADMIN}/customers`
ROUTES.ADD_CUSTOMER = `${ROUTES.CUSTOMER}/create`
ROUTES.VIEW_CUSTOMER = `${ROUTES.CUSTOMER}/:customer_id`
ROUTES.PRODUCT = `${ROUTES.ADMIN}/products`
ROUTES.ALL_PRODUCTS = `${ROUTES.PRODUCT}/all-products`
ROUTES.ADD_PRODUCT = `${ROUTES.ALL_PRODUCTS}/create`
ROUTES.VIEW_PRODUCT = `${ROUTES.ALL_PRODUCTS}/:product_id`
ROUTES.CATEGORIES = `${ROUTES.PRODUCT}/categories`
ROUTES.ADD_CATEGORY = `${ROUTES.CATEGORIES}/create`
ROUTES.VIEW_CATEGORY = `${ROUTES.CATEGORIES}/:category_id`
ROUTES.SETTINGS = `${ROUTES.ADMIN}/settings`
ROUTES.ACCOUNT_SETTINGS = `${ROUTES.SETTINGS}/accountsettings`
ROUTES.USER_PROFILE = `${ROUTES.SETTINGS}/userprofile`
ROUTES.ORDERS = `${ROUTES.ADMIN}/orders`
ROUTES.CREATE_ORDER = `${ROUTES.ORDERS}/create`
ROUTES.VIEW_ORDER = `${ROUTES.ORDERS}/:order_id`
ROUTES.PICK_UP_AND_DELIVERY = `${ROUTES.SETTINGS}/pickup&delivery`
ROUTES.INVENTORY = `${ROUTES.ADMIN}/inventory`
ROUTES.PAYMENT = `${ROUTES.SETTINGS}/payment`
ROUTES.TAX = `${ROUTES.SETTINGS}/taxes`
ROUTES.REPORTS = `${ROUTES.ADMIN}/reports`
ROUTES.REPORT_PRODUCTS = `${ROUTES.REPORTS}/products`
ROUTES.REPORT_LOCATIONS = `${ROUTES.REPORTS}/locations`
ROUTES.DIRECT_CHECKOUT = "/checkout/:order_uuid?"
ROUTES.REDIRECT_CHECKOUT_COINSPH = "/checkout/redirect/coinsph"
ROUTES.CHECKOUT_PRODUCT_DETAILS = `${ROUTES.DIRECT_CHECKOUT}/:type/:product_id`
ROUTES.REFERRAL = `${ROUTES.ADMIN}/referral`
ROUTES.UNSUBSCRIBECONFIRMATION = `${ROUTES.UNSUBSCRIBE}/confirmation`
ROUTES.SUBSCRIPTION_RETURN = `${ROUTES.SUBSCRIPTION_PAYMENT}/return`
ROUTES.SUBSCRIPTION_CANCEL = `${ROUTES.SUBSCRIPTION_PAYMENT}/cancel`

export default ROUTES
